<template>
  <div class="container mb-4">
    <div class="my--coin-transfer">
      <coin-transfer-header />
      <SectionLoader :show="loading" />
      <v-simple-table class="mt-4">
        <thead>
          <tr>
            <th class="text-left">
              {{ $t('coins.refNumber') }}
            </th>
            <th class="text-left" style="min-width: 200px">
              {{ $t('coins.desc') }}
            </th>
            <th class="text-left"></th>
            <th class="text-center">
              {{ $t('coins.amount') }}
            </th>
            <th class="text-left" style="min-width: 200px">
              {{ $t('coins.notes') }}
            </th>
            <th class="text-left">
              {{ $t('coins.transferDate') }}
            </th>
            <th class="text-left">
              {{ $t('coins.purchaseDate') }}
            </th>
            <th class="text-left">
              {{ $t('coins.expiredDate') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(transfer, index) in transfers" :key="`coin-transfer-${index}`">
            <td>
              {{ transfer.ref_number }}
            </td>
            <td>{{ generateDescription(transfer) }}</td>
            <td>
              <div v-if="transfer.direction === 'OUT'" class="direction--out">
                <v-icon>mdi-arrow-top-right</v-icon>
              </div>
              <div v-else-if="transfer.direction === 'IN'" class="direction--in">
                <v-icon>mdi-arrow-bottom-left</v-icon>
              </div>
            </td>
            <td class="transfer--amount">
              {{ transfer.direction === 'OUT' ? transfer.amount * -1 : transfer.amount }}
            </td>
            <td>{{ transfer.notes }}</td>
            <td>{{ $date.format(transfer.created_at, 'dd MMM yyyy') }}</td>
            <td>{{ $date.format(transfer.acquired_at, 'dd MMM yyyy') }}</td>
            <td>{{ $date.format(transfer.expired_at, 'dd MMM yyyy') }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <pagination
        :push-state="false"
        :meta="transfersMeta.pagination"
        @changePage="changePage"
        :maxVisibleButtons="5"
        v-if="transfersMeta"
      />
    </div>
  </div>
</template>

<script>
import CoinTransferHeader from '@/components/coins-usage/coin-transfer-header.vue';
import SectionLoader from '@/components/content-loading/section-loading';
import Pagination from '@/components/utils/fractal-pagination';
import { mapState } from 'vuex';

export default {
  name: 'index',
  components: {
    CoinTransferHeader,
    SectionLoader,
    Pagination,
  },
  data() {
    return {
      tab: 'tab-0',
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.coins.loading,
      transfers: (state) => state.coins.transfers,
      transfersMeta: (state) => state.coins.transfersMeta,
    }),
  },
  async mounted() {
    await this.$store.dispatch('coins/getAllTransfers', 1);
  },
  methods: {
    async changePage(page) {
      await this.$store.dispatch('coins/getAllTransfers', page);
    },
    generateDescription(item) {
      let description = 'Anda ';
      if (item.direction === 'OUT') description += `men-transfer ${item.amount} koin ke `;
      if (item.direction === 'IN')
        description += `menerima ${item.amount} koin hasil transfer dari `;
      description += `${item.party.name}. (${item.party.phone})`;
      return description;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/utils/variables';
.container {
  padding-top: 0;
}
.my--coin-transfer {
  border: solid 1px $color-gray-1;
  border-radius: 16px;
  padding: 12px 24px;

  @media #{$phones} {
    border: none;
    padding: 12px 0;
  }

  .v-data-table thead tr {
    background-color: $color-beliruma-1;

    th {
      color: $color-white !important;
    }
  }

  .transfer--btn {
    min-width: 170px;
    font-size: $font-sm;
  }

  .direction--out {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-beliruma-1;
    border-radius: 50%;
    .v-icon {
      color: white;
    }
  }

  .direction--in {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-beliruma-3;
    border-radius: 50%;
    .v-icon {
      color: white;
    }
  }

  .transfer--amount {
    font-family: Poppins-SemiBold, sans-serif;
    text-align: center;
  }
}
</style>
